import * as React from 'react';
import { inject, observer } from 'mobx-react';
import {
    STORE_TEST_PROJECT,
    STORE_TEST_PROJECT_DASHBOARD,
    STORE_TEST_PROJECT_INPUT_EDITOR,
    STORE_TEST_PROJECT_WIZARD,
    STORE_TEST_PROJECT_RUN_COMPARE
} from '../stores/constants';
import { TestProjectStores } from '../stores';
import { TestProjectDashboard } from '../components';
import { HasPermission } from '../../authorization/components/HasPermission';
import { AppPermissions } from '../../authorization/Permissions';

const TestProjectDashboardPage: React.FC<TestProjectStores> = ({
    projectTestProjectsUI,
    projectTestProjectsWizardUI,
    projectTestProjectsDashboardUI,
    projectTestProjectsInputEditorUI,
    projectTestProjectsRunCompareUI
}) => {
    if (
        !projectTestProjectsUI ||
        !projectTestProjectsWizardUI ||
        !projectTestProjectsDashboardUI ||
        !projectTestProjectsInputEditorUI ||
        !projectTestProjectsRunCompareUI
    ) {
        return null;
    }

    const testProjectDataStore = projectTestProjectsDashboardUI.currentTestProjectDataStore;

    if (!testProjectDataStore) {
        return null;
    }

    return (
        <HasPermission permissionClaim={AppPermissions.CanManageTestProjects}>
            <TestProjectDashboard
                key={`${testProjectDataStore.projectId}:${testProjectDataStore.testProjectId}`}
                store={projectTestProjectsDashboardUI}
                testProjectDataStore={testProjectDataStore}
                wizardStore={projectTestProjectsWizardUI}
                inputEditorStore={projectTestProjectsInputEditorUI}
                runCompareStore={projectTestProjectsRunCompareUI}
            />
        </HasPermission>
    );
};

export default inject(
    STORE_TEST_PROJECT,
    STORE_TEST_PROJECT_WIZARD,
    STORE_TEST_PROJECT_DASHBOARD,
    STORE_TEST_PROJECT_INPUT_EDITOR,
    STORE_TEST_PROJECT_RUN_COMPARE
)(observer(TestProjectDashboardPage));
